var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.down_time <= 10)?_c('div',{staticClass:"main-down",on:{"click":_vm.reloadTime}},[_c('div',{staticClass:"down_time"},[_vm._v(_vm._s(_vm.down_time)+" s")]),_c('div',{staticClass:"down_tips"},[_vm._v("后无操作自动返回首页")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }